import { useRouter } from 'next/router';
import React, { useContext, useEffect } from 'react';
import { POPULAR_BRANDS } from 'src/constants/brand';
import type { BrandSchema } from 'src/models/brand/schema';
import { BrandsContext } from 'src/stores/Brands';
import { I18nContext } from 'src/stores/I18n';
import { mixpanel } from 'src/utils/mixpanel';
import { Presenter } from './Presenter';

type Props = {
  activeBrandId: number;
  setActiveBrandId: React.Dispatch<React.SetStateAction<number>>;
  categorySlug: string;
  defaultBrandSlug?: string;
};

export const FilteredBrands: React.FC<Props> = ({
  activeBrandId,
  setActiveBrandId,
  categorySlug,
  defaultBrandSlug
}) => {
  const { query } = useRouter();
  const brands = useContext(BrandsContext);
  const localeResources = useContext(I18nContext);
  const popularBrandSmallCategoryXSlugs = POPULAR_BRANDS.find((pb) => pb.smallCategorySlug === query.slug);
  const popularBrandNameXSlugMaps = popularBrandSmallCategoryXSlugs?.brandSlugs
    .map((slug) => brands.find((brand) => brand.slug === slug))
    .filter((brand): brand is BrandSchema => brand !== undefined)
    .map((brand) => ({
      smallCategorySlug: popularBrandSmallCategoryXSlugs?.smallCategorySlug,
      id: brand.brandId,
      name: brand.name,
      slug: brand.slug
    }));

  const handleClick = (brandId: number) => {
    brandId === activeBrandId ? setActiveBrandId(0) : setActiveBrandId(brandId),
      mixpanel.track('BrandKeywordInCategoryClicked', {
        brandId: brandId
      });
  };

  useEffect(() => {
    if (defaultBrandSlug) {
      const defaultBrandId = brands.find((brand) => brand.slug === defaultBrandSlug)?.brandId;
      if (defaultBrandId) setActiveBrandId(defaultBrandId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categorySlug, defaultBrandSlug]);

  if (popularBrandNameXSlugMaps === undefined || popularBrandNameXSlugMaps.length === 0) return null;
  return (
    <Presenter
      popularBrandsData={popularBrandNameXSlugMaps}
      activeBrandId={activeBrandId}
      handleClick={handleClick}
      title={localeResources.popularBrand.title}
    />
  );
};
